require('./_objectAssignPolyfill');
var React = require('react');
module.exports = function RoundMoreVert(props) {
     return React.createElement(
          'svg',
          Object.assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
          React.createElement('path', { d: 'M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z', fill: 'currentColor' })
     );
};